import React, { useState } from 'react';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/MapSection/MapSection.styles';
import { Box, Button, Typography } from '@mui/material';
import { RiExpandDiagonal2Line } from 'react-icons/ri';
import {
  Typography700,
  ImgBox,
  // ExpandableDescriptionV2,
} from 'views/rebranded-module/common/components';
import dynamic from 'next/dynamic';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

const ExpandedMapDialog = dynamic(() => import(
  'views/rebranded-module/tours-module/TourViewV2/components/MapSection/ExpandedMapDialog'
).then((file) => file.ExpandedMapDialog));

const MapSection = (props) => {
  const { content, tour } = props;
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  return (
    <StyledBox>
      <Box className="MSImageAndBtnContiner">
        <Box className="MSImageContiner">
          <ImgBox
            image={{
              src: tour.map.large_url,
              alt: tour.name,
            }}
            width="100%"
            height="100%"
          />
        </Box>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<RiExpandDiagonal2Line />}
          className="MSExpandBtn"
          onClick={handleClickOpen}>
          {content.TourDetailsPage.expandMap}
        </Button>
      </Box>
      <Box className="MSTextContainer">
        <Typography700 variant="h6" component="p">
          {content.TourDetailsPage.mapSectionTitle}
        </Typography700>
        <Typography variant="body1" component="p">
          {interpolateString(content.TourDetailsPage.distanceDisplay, {
            miles: tour.distance.miles,
            km: tour.distance.km,
          })}
        </Typography>
        {/* {tour.description && (
          <ExpandableDescriptionV2
            description={tour.description}
            collapsedSize={72}
            content={content.ExpandableSectionComponent}
          />
        )} */}
      </Box>
      {open && (
        <ExpandedMapDialog
          open={open}
          handleClose={handleClose}
          image={{
            src: tour.map.large_url,
            alt: tour.name,
          }}
        />
      )}
    </StyledBox>
  );
};

export { MapSection };
